(() => {
  if(window.__zicoPersonalShoppingInitialized)return;
  window.__zicoPersonalShoppingInitialized=true;
  const memory=new Map(), cache=new Map(), unavailable=new Set(), pendingWrites=new Set();
  const WISH='zico:wishlist:v1', RECENT='zico:recent:v1';
  let serial=0;
  const valid=entry=>entry&&typeof entry.handle==='string'&&entry.handle.length<200&&!/[/?#]/.test(entry.handle);
  const key=entry=>`${entry.handle}:${entry.colour||''}`;
  const remember=(items,entry,limit=12)=>valid(entry)?[entry,...items.filter(item=>valid(item)&&key(item)!==key(entry))].slice(0,limit):items;
  const read=(name,recover=false)=>{
    if(pendingWrites.has(name)){
      if(recover)save(name,memory.get(name)||[]);
      return memory.get(name)||[];
    }
    if(unavailable.has(name)&&!recover)return memory.get(name)||[];
    try {
      const entries=JSON.parse(localStorage.getItem(name)||'[]');
      const items=Array.isArray(entries)?entries.filter(valid).slice(0,80):[];
      memory.set(name,items);unavailable.delete(name);return items;
    }
    catch { unavailable.add(name);return memory.get(name)||[]; }
  };
  const save=(name,items)=>{
    memory.set(name,items);
    try { localStorage.setItem(name,JSON.stringify(items));unavailable.delete(name);pendingWrites.delete(name); } catch { unavailable.add(name);pendingWrites.add(name); }
  };
  window.ZicoPersonalShopping={remember,read,save,key};
  const entryOf=button=>{
    const card=button.closest('product-component,.zv7-card,.zico-ymal-card');
    const info=button.closest('product-info');
    const link=card?.querySelector('a.zico-card-media-link,a.zv7-card__link,a[href*="/products/"]');
    const variant=card?new URL(link?.href||location.href).searchParams.get('variant'):(info?.querySelector('input[name=id]')?.value||new URL(location.href).searchParams.get('variant'));
    let colour=card?.dataset.zProductColour||card?.querySelector('.zv7-card__color')?.textContent.trim()||button.dataset.colour||'';
    if(info)colour=info.querySelector('[data-zico-color-option-group] input:checked')?.value||info.querySelector('.zico-ridar-family legend')?.textContent.replace(/^Color:\s*/,'').trim()||colour;
    return {handle:button.dataset.handle,variant:variant||button.dataset.variant,colour,at:Date.now()};
  };
  const text=(node,value)=>{if(node&&node.textContent!==value)node.textContent=value;};
  const compactPickers=()=>document.querySelectorAll('product-info [data-zico-size-guide]').forEach(guide=>{
    const root=guide.closest('product-info');
    const heading=root.querySelector('[data-zico-size-option-group] .form__label');
    const chart=guide.querySelector('[data-zico-chart-open]');
    if(!heading||!chart)return;
    if(!heading.querySelector('[data-z-size-chart-entry]')){
      const entry=document.createElement('button');
      entry.type='button';entry.className='z-size-chart-entry';entry.dataset.zSizeChartEntry='';
      entry.textContent='Size Chart';entry.setAttribute('aria-haspopup','dialog');
      entry.setAttribute('aria-controls',chart.getAttribute('aria-controls'));
      heading.append(entry);
    }
    guide.dataset.compactPicker='true';
  });
  const alignRelatedRails=()=>{
    const item=[...document.querySelectorAll('.zico-ymal__panel:not([hidden]) .zico-ymal__item')].find(e=>e.getBoundingClientRect().width>0);
    if(!item)return;
    const width=item.getBoundingClientRect().width+'px';
    document.querySelectorAll('.z-personal-rail').forEach(rail=>{
      if(rail.style.getPropertyValue('--z-related-card-width')!==width)rail.style.setProperty('--z-related-card-width',width);
    });
  };
  const sync=()=>{
    compactPickers();alignRelatedRails();
    document.querySelectorAll('[data-z-wishlist-items] modal-opener .quick-add__submit').forEach(button=>{
      const label=button.querySelector(':scope > .visually-hidden');
      if(!label)return;
      label.classList.remove('visually-hidden');
      button.querySelectorAll(':scope > span[aria-hidden="true"]').forEach(span=>{if(span.textContent.trim()==='+')span.remove();});
    });
    const items=read(WISH);
    document.querySelectorAll('[data-z-wish]').forEach(button=>{
      const active=items.some(item=>key(item)===key(entryOf(button)));
      const productTitle=button.dataset.zWishTitle||button.dataset.handle||'this product';
      button.disabled=false;button.setAttribute('aria-pressed',String(active));
      button.title=active?'Remove from wishlist':'Add to wishlist';button.setAttribute('aria-label',`${active?'Remove':'Add'} ${productTitle} ${active?'from':'to'} wishlist`);
      text(button.querySelector('[data-z-wish-label]'),active?'Saved to wishlist':'Add to wishlist');
    });
    document.querySelectorAll('[data-z-wishlist-open]').forEach(button=>button.disabled=false);
    document.querySelectorAll('[data-z-wish-count]').forEach(node=>{text(node,String(items.length));node.hidden=!items.length;});
  };
  const uniqueIds=scope=>{
    const suffix=`-personal-${++serial}`, ids=new Map();
    scope.querySelectorAll('[id]').forEach(node=>{ids.set(node.id,node.id+suffix);node.id+=suffix;});
    scope.querySelectorAll('*').forEach(node=>{
      for(const attribute of ['for','form','aria-labelledby','aria-describedby','aria-controls']) {
        const value=node.getAttribute(attribute);if(value)node.setAttribute(attribute,value.split(' ').map(id=>ids.get(id)||id).join(' '));
      }
      const href=node.getAttribute('href');if(href?.startsWith('#')&&ids.has(href.slice(1)))node.setAttribute('href','#'+ids.get(href.slice(1)));
      for(const attribute of ['data-modal','data-target']) {
        const value=node.getAttribute(attribute);
        if(value?.startsWith('#')&&ids.has(value.slice(1)))node.setAttribute(attribute,'#'+ids.get(value.slice(1)));
      }
    });
  };
  const cardHTML=(entry,related=false)=>{
    const id=`${related?'related':'saved'}:${entry.handle}:${entry.variant||''}`;
    if(!cache.has(id)) {
      const prefix=window.Shopify?.routes?.root||'/';
      const url=new URL(prefix+'products/'+encodeURIComponent(entry.handle),location.origin);
      url.searchParams.set('section_id',related?'zico-related-card':'zico-saved-card');if(entry.variant)url.searchParams.set('variant',entry.variant);
      const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
      cache.set(id,fetch(url,{signal:AbortSignal.timeout(20000)}).then(async response=>{
        if(!response.ok)throw Error('Product unavailable');
        const html=new DOMParser().parseFromString(await response.text(),'text/html');
        const card=html.querySelector('[data-z-saved-card]');if(!card)throw Error('Product unavailable');
        return card.innerHTML;
      }).catch(error=>{cache.delete(id);throw error;}));
    }
    return cache.get(id);
  };
  const render=async(container,entries)=>{
    const ticket=container._zRenderTicket=(container._zRenderTicket||0)+1;
    container.setAttribute('aria-busy','true');
    const nodes=new Array(entries.length);let index=0;
    const worker=async()=>{while(index<entries.length&&ticket===container._zRenderTicket) {
      const position=index++,entry=entries[position];
      const li=document.createElement('li');
      try {li.innerHTML=await cardHTML(entry,container.hasAttribute('data-z-recent-items'));uniqueIds(li);}
      catch {
        const a=document.createElement('a');a.href=(window.Shopify?.routes?.root||'/')+'products/'+encodeURIComponent(entry.handle);a.textContent=entry.handle.replaceAll('-',' ');li.append(a);
        const note=document.createElement('p');note.textContent='Product could not be loaded.';li.append(note);
        const retry=document.createElement('button');retry.type='button';retry.className='z-text-action';retry.textContent='Retry';retry.addEventListener('click',()=>render(container,container.hasAttribute('data-z-wishlist-items')?read(WISH):entries));li.append(retry);
        if(container.hasAttribute('data-z-wishlist-items')) {
          const remove=document.createElement('button');remove.type='button';remove.className='z-text-action';remove.textContent='Remove';
          Object.assign(remove.dataset,{zWish:'',handle:entry.handle,variant:entry.variant||'',colour:entry.colour||''});li.append(remove);
        }
      }
      li.dataset.zSavedKey=key(entry);nodes[position]=li;
    }};
    await Promise.all(Array.from({length:Math.min(3,entries.length)},worker));
    if(ticket!==container._zRenderTicket)return;
    container.replaceChildren(...nodes);container.removeAttribute('aria-busy');
    window.ZicoCardColours?.safeHover&&container.querySelectorAll('product-component').forEach(window.ZicoCardColours.safeHover);
    document.dispatchEvent(new CustomEvent('zico:products-appended',{detail:{scope:container,items:nodes}}));
    sync();updateArrows();
  };
  const current=()=>document.querySelector('product-info[id^=MainProduct] .z-wish--product');
  const record=()=>{
    const button=current();if(!button)return;
    const entry=entryOf(button);save(RECENT,remember(read(RECENT),entry));sync();
  };
  const recent=()=>{
    const section=document.querySelector('[data-z-recent]');if(!section)return;
    const entry=current()?entryOf(current()):null;
    const seen=new Set();
    const items=read(RECENT).filter(item=>{
      const id=item.handle+':'+(item.variant||'');
      if(seen.has(id)||entry&&(item.handle===entry.handle&&item.variant===entry.variant))return false;
      seen.add(id);return true;
    }).slice(0,6);
    section.hidden=!items.length;if(!items.length)return;
    const load=()=>render(section.querySelector('[data-z-recent-items]'),items);
    if('IntersectionObserver' in window) {
      const observer=new IntersectionObserver(es=>{if(es.some(e=>e.isIntersecting)){observer.disconnect();load();}},{rootMargin:'200px'});observer.observe(section);
    }else load();
  };
  const updateArrows=()=>document.querySelectorAll('.z-personal-rail').forEach(rail=>{
    const track=rail.querySelector('.z-personal-rail__track');
    rail.querySelectorAll('[data-z-rail-step]').forEach(button=>button.disabled=Number(button.dataset.zRailStep)<0?track.scrollLeft<2:track.scrollLeft>=track.scrollWidth-track.clientWidth-2);
  });
  const init=()=>{
    const dialog=document.getElementById('ZicoWishlist');if(!dialog)return;
    let opener;
    const refreshWishlist=()=>{
      const items=read(WISH);dialog.querySelector('[data-z-wishlist-empty]').hidden=!!items.length;
      text(dialog.querySelector('[data-z-wishlist-status]'),unavailable.has(WISH)?'Browser storage is unavailable. Saved for this visit only.':items.length?`${items.length} saved ${items.length===1?'item':'items'}`:'');
      return render(dialog.querySelector('[data-z-wishlist-items]'),items);
    };
    document.addEventListener('click',event=>{
      // Native quick-add moves to body and must not remain behind a top-layer dialog.
      if(dialog.open&&dialog.contains(event.target)&&event.target.closest('modal-opener'))dialog.close();
    },{capture:true});
    document.addEventListener('click',async event=>{
      const chartEntry=event.target.closest('[data-z-size-chart-entry]');
      if(chartEntry){
        event.preventDefault();
        // Do not let the original click close the dialog opened by the forwarded click.
        event.stopImmediatePropagation();
        const chart=chartEntry.closest('product-info')?.querySelector('[data-zico-chart-open]');
        const chartDialog=document.getElementById(chart?.getAttribute('aria-controls'));
        if(chartDialog&&!chartDialog.open)chartDialog.addEventListener('close',()=>chartEntry.focus({preventScroll:true}),{once:true});
        chart?.click();
        return;
      }
      const wish=event.target.closest('[data-z-wish]');
      if(wish) {
        event.preventDefault();event.stopPropagation();
        const entry=entryOf(wish),items=read(WISH),exists=items.some(item=>key(item)===key(entry));
        save(WISH,exists?items.filter(item=>key(item)!==key(entry)):remember(items,entry,80));sync();
        if(!exists)document.dispatchEvent(new CustomEvent('zico:wishlist-added',{detail:{button:wish}}));
        text(document.querySelector('[data-z-shopping-status]'),exists?'Removed from wishlist':'Saved to wishlist');
        if(dialog.open) {await refreshWishlist();dialog.querySelector('[data-z-wish], [data-z-wishlist-close]')?.focus({preventScroll:true});}
      }
      if(event.target.closest('[data-z-wishlist-open]')) {
        opener=event.target.closest('[data-z-wishlist-open]');cache.clear();
        if(!dialog.open)dialog.showModal();dialog.querySelector('[data-z-wishlist-close]').focus();refreshWishlist();
      }
      if(event.target.closest('[data-z-wishlist-close]'))dialog.close();
      if(event.target.closest('[data-z-clear-recent]')){save(RECENT,[]);document.querySelector('[data-z-recent]').hidden=true;}
      const step=event.target.closest('[data-z-rail-step]');
      if(step) {const track=step.closest('.z-personal-rail').querySelector('.z-personal-rail__track');track.scrollBy({left:Number(step.dataset.zRailStep)*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}
    },{capture:true});
    dialog.addEventListener('click',event=>{
      if(event.target!==dialog)return;
      const bounds=dialog.getBoundingClientRect();
      if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();
    });
    dialog.addEventListener('close',()=>opener?.focus({preventScroll:true}));
    const recoverWishlist=()=>read(WISH,true);
    window.addEventListener('storage',event=>{if(event.key===WISH||event.key===null){if(event.key===null){pendingWrites.delete(WISH);memory.delete(WISH);}recoverWishlist();sync();if(dialog.open)refreshWishlist();}});
    window.addEventListener('pageshow',()=>{recoverWishlist();sync();if(dialog.open)refreshWishlist();});
    document.addEventListener('zico:card-colour-change',sync);
    document.addEventListener('zico:products-appended',()=>requestAnimationFrame(()=>{sync();updateArrows();}));
    document.addEventListener('product-info:loaded',record);
    if(typeof subscribe==='function')subscribe(PUB_SUB_EVENTS.variantChange,({data}={})=>{
      const id=`ZicoMemberBenefit-${data?.sectionId||''}`;
      const current=document.getElementById(id),next=data?.html?.getElementById(id);
      if(current&&next)current.replaceWith(next.cloneNode(true));
      requestAnimationFrame(record);
    });
    let frame;
    new MutationObserver(records=>{
      if(!records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1)))return;
      cancelAnimationFrame(frame);frame=requestAnimationFrame(sync);
    }).observe(document.getElementById('MainContent'),{childList:true,subtree:true});
    document.querySelectorAll('.z-personal-rail__track').forEach(track=>track.addEventListener('scroll',updateArrows,{passive:true}));
    window.addEventListener('resize',()=>{alignRelatedRails();updateArrows();},{passive:true});
    const anchor=[...document.querySelectorAll('#MainContent h2')].find(e=>e.textContent.trim()==='FOR YOU')?.closest('.shopify-section');
    const rails=[...document.querySelectorAll('.z-personal-rail')];
    if(current()&&anchor&&rails.length)anchor.before(...rails);
    record();sync();recent();updateArrows();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

